// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.next-page-confirmation-modal .modal-dialog {
    max-width: 50%;
    margin-top: 8%;
}

.next-page-confirmation-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}

.next-page-confirmation-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
}

.next-page-confirmation-modal .modal-header-title-section {
    display: grid;
    width: 100%;
    align-items: center;
    justify-items: center;
    grid-template-columns: 1fr;
    grid-row-gap: 5px;
}


.next-page-confirmation-modal .modal-header-title-section .modal-title {
    font: normal normal bold 22px/27px Lato;
    letter-spacing: 0.22px;
    color: var(--neutral-color7);
}

.next-page-confirmation-modal .modal-header-title-section .modal-title:last-child {
    font: normal normal normal 18px/22px Lato;
    letter-spacing: 0.18px;
}

.next-page-confirmation-modal .modal-header-title-section span {
    margin-left: 15px;
    font: normal normal 300 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color5);
}

.next-page-confirmation-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
}

.next-page-confirmation-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {
    margin-right: 10px;
}

.next-page-confirmation-modal .modal-body {
    max-height: 300px;
    padding-top: 8px;
    overflow: hidden;
}


.modal-body .wrapper-modal-body .next-page-confirmation-modal-card-item-group {
    display: grid;
    grid-row-gap: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #CCCCCC;
}

.modal-body .wrapper-modal-body .next-page-confirmation-modal-card-item-group .next-page-confirmation-modal-card-item-inner-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;
}


.modal-body .wrapper-modal-body .revart-back-modal-card-item-group {
    grid-template-columns: 1fr;
}


/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    .next-page-confirmation-modal .modal-dialog .modal-content{
        padding: 0 var(--padding-left);
    }
    .next-page-confirmation-modal .modal-body{
        padding: 0;
    }

    .next-page-confirmation-modal .modal-body .wrapper-modal-body{
        overflow-y: scroll;
    }
    .next-page-confirmation-modal .modal-header-title-section svg{
        width: 31px;
        height: 31px;
    }
    .next-page-confirmation-modal .modal-header-title-section .modal-title:last-child{
        font: normal normal normal 16px/19px Lato;
        letter-spacing: 0.16px;
    } 



}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/NextPageConfirmationModal.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;IAC1B,iBAAiB;AACrB;;;AAGA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;;AAGA;IACI,0BAA0B;AAC9B;;;AAGA,wCAAwC;AACxC;IACI;QACI,8BAA8B;IAClC;IACA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,yCAAyC;QACzC,sBAAsB;IAC1B;;;;AAIJ","sourcesContent":[".next-page-confirmation-modal .modal-dialog {\r\n    max-width: 50%;\r\n    margin-top: 8%;\r\n}\r\n\r\n.next-page-confirmation-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.next-page-confirmation-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n}\r\n\r\n.next-page-confirmation-modal .modal-header-title-section {\r\n    display: grid;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-items: center;\r\n    grid-template-columns: 1fr;\r\n    grid-row-gap: 5px;\r\n}\r\n\r\n\r\n.next-page-confirmation-modal .modal-header-title-section .modal-title {\r\n    font: normal normal bold 22px/27px Lato;\r\n    letter-spacing: 0.22px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.next-page-confirmation-modal .modal-header-title-section .modal-title:last-child {\r\n    font: normal normal normal 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n}\r\n\r\n.next-page-confirmation-modal .modal-header-title-section span {\r\n    margin-left: 15px;\r\n    font: normal normal 300 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color5);\r\n}\r\n\r\n.next-page-confirmation-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.next-page-confirmation-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {\r\n    margin-right: 10px;\r\n}\r\n\r\n.next-page-confirmation-modal .modal-body {\r\n    max-height: 300px;\r\n    padding-top: 8px;\r\n    overflow: hidden;\r\n}\r\n\r\n\r\n.modal-body .wrapper-modal-body .next-page-confirmation-modal-card-item-group {\r\n    display: grid;\r\n    grid-row-gap: 20px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px solid #CCCCCC;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .next-page-confirmation-modal-card-item-group .next-page-confirmation-modal-card-item-inner-group {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n\r\n.modal-body .wrapper-modal-body .revart-back-modal-card-item-group {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    .next-page-confirmation-modal .modal-dialog .modal-content{\r\n        padding: 0 var(--padding-left);\r\n    }\r\n    .next-page-confirmation-modal .modal-body{\r\n        padding: 0;\r\n    }\r\n\r\n    .next-page-confirmation-modal .modal-body .wrapper-modal-body{\r\n        overflow-y: scroll;\r\n    }\r\n    .next-page-confirmation-modal .modal-header-title-section svg{\r\n        width: 31px;\r\n        height: 31px;\r\n    }\r\n    .next-page-confirmation-modal .modal-header-title-section .modal-title:last-child{\r\n        font: normal normal normal 16px/19px Lato;\r\n        letter-spacing: 0.16px;\r\n    } \r\n\r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
